module.exports = __webpack_public_path__ + "img/miniProgram.b014bc21.png";